import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { Icon } from "@iconify/react";
import { Button, Tabs } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { BrandingGuidelines } from "./BrandingGuidelines/BrandingGuidelines";
import { News } from "./News/News";

export const MediaCentre = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();

  useEffect(() => {
    if (query.get("id")) {
      return;
    }
    if (!query.get("activeTab")) {
      navigate(
        `/dedicated/corporate/media-centre?activeTab=news&subActiveTab=latestNewsPageHeading`,
        {
          replace: true,
        }
      );
    }
    if (query.get("activeTab") === "news") {
      navigate(
        `/dedicated/corporate/media-centre?activeTab=news&subActiveTab=${query.get("subActiveTab") || "latestNewsPageHeading"}`,
        { replace: true }
      );
    }
    if (query.get("activeTab") === "brandingGuidelines") {
      navigate(
        `/dedicated/corporate/media-centre?activeTab=brandingGuidelines&subActiveTab=${query.get("subActiveTab") || "brandingGuidelinesPageHeading"}`,
        {
          replace: true,
        }
      );
    }
  }, [query.get("activeTab"), query.get("subActiveTab")]);

  const items = [
    {
      label: "News",
      key: "news",
      children: <News />,
    },
    {
      label: "Branding Guidelines",
      key: "brandingGuidelines",
      children: <BrandingGuidelines />,
    },
  ];

  return (
    <ContentWrapper
      title={"Media Center"}
      actionItems={
        query.get("subActiveTab") === "newsPageContent" && (
          <Button
            onClick={() => {
              navigate("/dedicated/corporate/media-centre/news/add");
            }}
            icon={<Icon icon={"lucide:plus"} />}
          >
            Add News
          </Button>
        )
      }
    >
      <Tabs
        activeKey={query?.get("activeTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`/dedicated/corporate/media-centre?activeTab=${activeKey}`, { replace: true });
        }}
      ></Tabs>
    </ContentWrapper>
  );
};
